module.exports = __webpack_public_path__ + "img/admin.f008261d.svg";